import axiosApi from './common/api';

const baseAPI = 'scrapper/';

class LinkService {

  getData(url: string) {
    try {
        return axiosApi.get(baseAPI + `?url=` + url).then((response: Response) => {
          return response;
        });
    } catch (error) {
      console.error("Error fetching links:", error);
      throw error;
    }    
  }
}

export default new LinkService();